import { useEffect, useState } from "react";
import axios from "../utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import {
  useAuthModal
} from "../context/AuthModalContext";

function AccountPage() {

const navigate = useNavigate();

const [user,setUser] = useState(null);
const [orders,setOrders] = useState([]);
const [loading,setLoading] = useState(true);
const {
  openAuthModal
} = useAuthModal();

useEffect(()=>{

axios.get("/api/user/me")
.then(res=>{
setUser(res.data);
})
.catch(err=>{
console.error("User fetch error",err);
});

axios.get("/api/orders/my-orders")
.then(res=>{
setOrders(res.data || []);
})
.catch(err=>{
console.error("Orders fetch error",err);
})
.finally(()=>{
setLoading(false);
});

},[]);


if(loading){
return(
<div className="p-16 text-center text-gray-500">
Loading account...
</div>
);
}

return(

<div className="max-w-7xl mx-auto p-10">

<h1 className="text-3xl font-serif italic mb-10">
Your Account
</h1>


<div className="grid md:grid-cols-4 gap-10">

{/* SIDEBAR */}

<div className="bg-white border rounded-xl p-6 h-fit shadow-sm">

{/* AVATAR */}

<div className="flex items-center gap-4 mb-6">

<div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center font-bold text-lg">
{user?.name?.charAt(0) || "C"}
</div>

<div>
<p className="text-xs text-gray-400">HELLO,</p>
<p className="font-semibold">{user?.name || "Customer"}</p>
</div>

</div>


{/* MENU */}

<div className="flex flex-col gap-3 text-sm">

<button className="bg-black text-white rounded-lg px-4 py-2 text-left">
👤 Profile Information
</button>

<button
onClick={()=>navigate("/my-orders")}
className="text-gray-600 px-4 py-2 text-left hover:text-black"
>
📦 My Orders
</button>

<button
onClick={()=>navigate("/wishlist")}
className="text-gray-600 px-4 py-2 text-left hover:text-black"
>
❤️ Wishlist
</button>

<button
onClick={() => {

  localStorage.removeItem("token");
  localStorage.removeItem("email");
  localStorage.removeItem("role");

  navigate("/");

}}
className="text-red-500 px-4 py-2 text-left"
>
🚪 Logout
</button>

</div>

</div>


{/* MAIN DASHBOARD */}

<div className="md:col-span-3 space-y-8">

{/* DASHBOARD CARDS */}

<div className="grid md:grid-cols-3 gap-6">

<div
onClick={()=>navigate("/my-orders")}
className="bg-white border rounded-xl p-6 cursor-pointer hover:shadow-md transition"
>

<div className="text-blue-500 text-3xl mb-2">📦</div>

<h3 className="font-semibold">
Your Orders
</h3>

<p className="text-sm text-gray-500">
Check status
</p>

</div>


<div
onClick={()=>navigate("/addresses")}
className="bg-white border rounded-xl p-6 cursor-pointer hover:shadow-md transition"
>

<div className="text-purple-500 text-3xl mb-2">📍</div>

<h3 className="font-semibold">
Addresses
</h3>

<p className="text-sm text-gray-500">
Manage delivery
</p>

</div>


<div
onClick={()=>navigate("/support")}
className="bg-white border rounded-xl p-6 cursor-pointer hover:shadow-md transition"
>

<div className="text-orange-500 text-3xl mb-2">🎧</div>

<h3 className="font-semibold">
Support
</h3>

<p className="text-sm text-gray-500">
Need help?
</p>

</div>

</div>


{/* RECENT ORDERS */}

<div className="bg-white border rounded-xl p-6">

<div className="flex justify-between mb-6">

<h2 className="text-lg font-semibold">
Recent Orders
</h2>

<button
onClick={()=>navigate("/my-orders")}
className="text-purple-600 text-sm font-semibold"
>
VIEW ALL
</button>

</div>


{orders.length === 0 ? (

<div className="text-center py-16 text-gray-400">

<div className="text-4xl mb-3">
📦
</div>

<p>You haven't placed any orders yet.</p>

</div>

) : (

<div className="space-y-4">

{orders.slice(0,3).map(order=>(

<div
key={order.id}
onClick={() =>
  navigate(
    `/track-order?id=${order.id}`
  )
}
className="
  border
  rounded-lg
  p-4
  flex
  justify-between
  items-center
  cursor-pointer
  hover:shadow-md
  hover:border-purple-400
  transition
"
>

<div>

<p className="font-medium">
Order #{order.id}
</p>

<p className="text-sm text-gray-500">
{order.createdAt}
</p>

</div>

<div>

<p className="font-semibold">
₹ {order.finalAmount || 0}
</p>

</div>

</div>

))}

</div>

)}

</div>


{/* PERSONAL DETAILS */}

<div className="bg-white border rounded-xl p-6">

<h2 className="font-semibold mb-6">
Personal Details
</h2>


<div className="grid md:grid-cols-2 gap-8">

<div>

<p className="text-xs text-gray-400">
YOUR NAME
</p>

<p className="font-medium">
{user?.name}
</p>

</div>


<div>

<p className="text-xs text-gray-400">
EMAIL ADDRESS
</p>

<p className="font-medium">
{user?.email}
</p>

</div>

</div>


<button
className="mt-6 font-semibold border-b border-black"
>
EDIT PROFILE INFORMATION
</button>

</div>

</div>

</div>

</div>

);

}

export default AccountPage;